import api from '../../helpers/axios'

export const state = {
    notes: null,
};

export const getters = {
    notes: (state) => state.notes,
};

export const mutations = {
    setNotes(state, newValue) {
        state.notes = newValue;
    },
};

export const actions = {
    createNote(_,  data) {
        return new Promise((resolve) => {
            api.post("/notes", data).then((res) => {
                if(res){
                    resolve(res.data.data)
                }
            })
        });
    },
    deleteNote(_, id) {
        return new Promise((resolve) => {
            api.delete("/notes/"+id).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchNotes({ commit },{id,page,limit}) {
        let query ='&'
        query += `page=${page}&`;
        query += `limit=${limit}&`;
        return new Promise((resolve) => {
            api.get("/notes?customerId="+id+query).then((res) => {
                commit("setNotes", res.data.data);
                resolve(res.data.data)
            })
        });
    }
};
